import { useMemo } from 'react';
import { useAppSettingsDictionary } from '../api';

export function useSessionIdle() {
  const appSettings = useAppSettingsDictionary().appSettingsData?.value;

  const { logoutTime, currentPageReturnTime, twoFAstateTimeout } =
    useMemo(() => {
      return {
        twoFAstateTimeout: appSettings?.twoFAstateTimeout,
        logoutTime: appSettings?.loginTimeout,
        currentPageReturnTime: appSettings?.currentPageReturnTime,
      };
    }, [appSettings]);

  const handleUpdateReturnInfo = () => {
    sessionStorage.setItem('returnPage', window.location.pathname);
    sessionStorage.setItem('returnTime', Date.now().toString());
  };

  const handleClearReturnInfo = () => {
    sessionStorage.removeItem('returnPage');
    sessionStorage.removeItem('returnTime');
  };

  const checkReturnPageValidity = () => {
    const returnPage = sessionStorage.getItem('returnPage');
    const returnTime = sessionStorage.getItem('returnTime');

    if (returnPage && returnTime && currentPageReturnTime) {
      const isValid = Date.now() - Number(returnTime) <= currentPageReturnTime;

      if (isValid) {
        handleClearReturnInfo();
      }
      return {
        isValid: isValid,
        page: returnPage,
      };
    }

    return { isValid: false, page: undefined };
  };

  return {
    twoFAstateTimeout,
    logoutTime,
    checkReturnPageValidity,
    handleUpdateReturnInfo,
  };
}
